import { render, staticRenderFns } from "./PluginIntroRowSlide.vue?vue&type=template&id=2b79488f&scoped=true"
import script from "./PluginIntroRowSlide.vue?vue&type=script&lang=js"
export * from "./PluginIntroRowSlide.vue?vue&type=script&lang=js"
import style0 from "./PluginIntroRowSlide.vue?vue&type=style&index=0&id=2b79488f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79488f",
  null
  
)

export default component.exports